import { useQuery } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import { CashAdvancesCustomerSchemas } from "api-types";
import type { AxiosResponse } from "axios";

import { useOfferRequestPath } from "../hooks/use-offer-request-path";

export const useGetSampleOfferMcaQuery = (advanceId?: number | null) => {
  const client = useAxios();
  const requestPath = useOfferRequestPath().getSampleOfferMca(advanceId);

  return useQuery({
    queryKey: ["getSampleOfferMca", advanceId],
    queryFn: () => client.get<CashAdvancesCustomerSchemas.CashAdvanceSummarySchema>(requestPath),
    select: ({ data }: AxiosResponse): CashAdvancesCustomerSchemas.CashAdvanceSummarySchema => data,
    throwOnError: true,
    enabled: !!advanceId,
  });
};
